export class BaseService {
    refreshTokenFromResponse(response) {
        if (!response || !response.headers || !response.headers["overwatch-token"]) {
            return;
        }
        localStorage.setItem( "overwatch-token", response.headers["overwatch-token"] );
    }
}